import { Col } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  findKeyValuePair, getFileUploadStatus, getIsPageNameDetail, getIsPageNameEdit, getIsPageNameEditDischarge,
  getIsPageNameNewAdmission,
  getIsPageNameReconsider,
} from '../../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../../store';
import { setIsMinimize, setIsModal } from '../../../store/actions/newAdmissionAction';
import { downloadDocumentGuids } from '../../../store/actions/newAdmissionAction';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { fetchOtherClaimDetailMandatoryClassifications } from '../../../store/actions/lookUpAction';
import { HIS_UPLOAD_STATUS, NEW_UPLOAD_STATUS } from '../../constants/crmConstants';

const HISFileUploadMinimize = ({ location: { pathname }, form }: any): ReactElement => {
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const isDetailPage = getIsPageNameDetail(pathname);
  const isEditPage = getIsPageNameEdit(pathname);
  const isEditDischargePage = getIsPageNameEditDischarge(pathname);
  const isEditReconsider = getIsPageNameReconsider(pathname);
  const {
    uploadedFiles: fileList, selectedBeneficiaryDetail, isShowAdmissionForm,
    isFileUploadEnabledForce, downloadDocumentGuidList, uploadedFiles,
    admissionFormVal, isDischargeCase, automatedProcedureOptions, selectedFiles,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const {
    isDraftBtnClicked, nextStatusFilters,
  } = useSelector((state: RootState): any => state?.selectedInPatientDetail || {});
  const { payerLookUp, payerList:
    { payer: { uniqueIdentifier, id, showOtherBuddhimedFlow } },
  }: any = useSelector((state: RootState): RootState => state);
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  const isDocumentEnabledChecklist = appDetail?.getIsDocumentChecklistEnabled();

  const [, setGlobalStatus] = useState<string>('');

  const dispatch = useDispatch();

  const openModal = (): void => {
    if (!isNewAdmissionPage || selectedBeneficiaryDetail || isShowAdmissionForm || isFileUploadEnabledForce) {
      dispatch(setIsMinimize(false));
      { isDraftBtnClicked && nextStatusFilters === 'DRAFT' ? dispatch(setIsModal(true)) : dispatch(setIsModal(false)); }
      fileList?.map((ele: any, index: number): any => {
        downloadDocumentGuidList?.push(ele?.docPath || ele?.response?.uploadedDetails?.map((element: any): any => {
          if (element?.fileGuid !== undefined && element?.fileGuid !== null) {
            downloadDocumentGuidList?.push(element?.fileGuid);
          }
        }));
      });
      dispatch(downloadDocumentGuids(downloadDocumentGuidList));
    }
  };

  useEffect((): void => {
    if (fileList?.length) {
      const gStatus = getFileUploadStatus<string>(fileList, ['Uploading...', 'Verifying...', 'Verified']);
      setGlobalStatus(gStatus);
    }
  }, [fileList]);

  useEffect((): any => {
    if (isDocumentEnabledChecklist && showOtherBuddhimedFlow && isDischargeCase) {
      const icdCode = findKeyValuePair(automatedProcedureOptions, 'id', (form?.getFieldsValue('automatedProcedure')?.automatedProcedure
        || admissionFormVal?.treatmentDetail?.automatedProcedure || claimDetails?.procedureDesc?.[0]?.payerMasterValue))?.icdCode
        || claimDetails?.icd10;

      const { masterLookId: insurerId } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', (form?.getFieldsValue('insurerName')?.insurerName ||
          admissionFormVal?.customerDetail?.insurerName || claimDetails?.insurerName)) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', (form?.getFieldsValue('insurerName')?.insurerName ||
          admissionFormVal?.customerDetail?.insurerName || claimDetails?.insurerName)) ||
        {};

      const payload = {
        payerID: id,

        claimStage: isDischargeCase ? 'DischargeDocumentsSubmitted' : 'NewAdmission',

        treatment: findKeyValuePair(automatedProcedureOptions, 'id',
          (form?.getFieldsValue('automatedProcedure')?.automatedProcedure ||
            admissionFormVal?.treatmentDetail?.automatedProcedure || claimDetails?.procedureDesc?.[0]?.payerMasterValue))?.name ||
          claimDetails?.procedureDesc?.[0]?.payerMasterValue || '',

        icd: !Array.isArray(icdCode) ? [icdCode] : icdCode || [],

        insurerName: insurerId,
      };
      dispatch(fetchOtherClaimDetailMandatoryClassifications(payload));
    }
  }, [claimDetails, admissionFormVal?.customerDetail?.insurerName, admissionFormVal?.treatmentDetail?.diagnosis]);

  const hisFileUploads = fileList?.filter((fileUid: any): any => fileUid?.claimStatus === HIS_UPLOAD_STATUS);
  const newFileUploads = fileList?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);
  const totalUploadedFiles = newFileUploads?.length + hisFileUploads?.length + selectedFiles?.length;

  const showDynamicText = totalUploadedFiles > 0 ? 'View Documents' : 'Add Documents';
  return (
    <>
      {
        isDetailPage || isEditPage || isEditDischargePage || isEditReconsider || isNewAdmissionPage ?
          <Col className="dynamictext">
            <a data-testid="modal-maximize-icon"
              onClick={openModal} className={(uploadedFiles?.length === 0
                && !isShowAdmissionForm) ? 'his-disabled-link' : 'enabled-link'}>
              <span>{showDynamicText}</span> {totalUploadedFiles > 0 && <span>({totalUploadedFiles})</span>}
            </a>

          </Col>
          : <></>
      }
    </>
  );
};

export default withRouter(HISFileUploadMinimize);
